import React from "react";
import { Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Radio from "@mui/material/Radio";

const Preview = ({
  questionBody,
  rows,
  correctAnswer,
  explanation,
  alphaArr,
}) => {
  return (
    <div>
      <div className="btmbdrgry">
        <h2>Preview</h2>
      </div>
      <Box sx={{ marginTop: "20px" }}>
        <h4>{questionBody ? "Q." + " " + questionBody : ""}</h4>
        <ul style={{ listStyleType: "none", padding: 0 }}>
          {rows?.map((el, i) => (
            <li key={i}>
              {el.responseText && (
                <>
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 26,
                        padding: 0,
                      },
                    }}
                  />
                  <Typography component="span" style={{ marginRight: "5px" }}>
                    {alphaArr[i] + " ."}
                  </Typography>
                </>
              )}
              {el.responseText}
            </li>
          ))}
        </ul>
        {correctAnswer && (
          <Typography component="span">
            <span sx={{ fontWeight: "bold" }}>Correct Answer :</span>{" "}
            {correctAnswer}
          </Typography>
        )}
        <br />
        {explanation && (
          <Typography component="span">
            <span sx={{ fontWeight: "bold" }}>Explanation :</span> {explanation}
          </Typography>
        )}
      </Box>
    </div>
  );
};

export default Preview;
